<template>
  <div data-testid="exterior-area-form">
    <HouseForm
      :index="index"
      :value="value"
      @input="(area) => $emit('input', area)"
      @delete="$emit('delete', index)"
    />
  </div>
</template>

<script>
import HouseForm from "./HouseForm.vue";

export default {
  name: "ExteriorAreaForm",

  components: { HouseForm },

  props: {
    index: {
      type: Number,
      required: true,
    },

    value: {
      type: Object,
      required: true,
    },
  },
};
</script>
